import{ CgDetailsMore } from "react-icons/cg";
import { useState } from "react";
import { Link } from "react-router-dom";
const Navbar = () =>{
    
  const [showIcons , setShowIcons]  = useState(false);

  return(
        <>
        <div>
          <nav>
          <div className="left">
        
          <Link to="/">
            <img className="nav_logo" src='../Images/logo.jpg' alt="Logo"></img>
            <span className="nav_title">Aman Verma</span>
            </Link>
          </div>

           <ul className={showIcons ? 'right_toggle' : 'right'}>
          {/* <Router> */}
            <li onClick={() => setShowIcons(false)}><Link to="/">Home</Link></li>
            <li onClick={() => setShowIcons(false)}><Link to="/about">About</Link></li>
            <li onClick={() => setShowIcons(false)}><Link to="/achievements">Achievements</Link></li>
            <li onClick={() => setShowIcons(false)}><Link to="/project">Projects</Link></li>
            <li onClick={() => setShowIcons(false)}><Link to="/resume">Resume</Link></li>
            <li onClick={() => setShowIcons(false)}><Link to="/contact">Contact Me</Link></li>
            {/* <li><NavLink to='/'>Home</NavLink></li>
            <li><NavLink to='/about'>About</NavLink></li>
            <li><NavLink to='/achivements'>Achievements</NavLink></li>
            <li><NavLink to='/projects'>Projects</NavLink></li>
            <li><NavLink to='/resume'>Resume</NavLink></li>
            <li><NavLink to='/contact'>Contact Me</NavLink></li> */}
          {/* </Router> */}
           </ul>
           <div className="arrow" onClick={() => setShowIcons(!showIcons)}><CgDetailsMore/></div> 
           </nav>
           
           </div>
        </>
    );
}
export default Navbar